var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.17596 8L8.8224 8.35355L6.18806 10.9879C6.13181 11.0442 6.10022 11.1204 6.10022 11.2C6.10022 11.2795 6.13181 11.3558 6.18806 11.4121C6.2443 11.4683 6.32055 11.4998 6.40005 11.4998C6.47957 11.4998 6.55584 11.4683 6.6121 11.412L9.17596 8ZM9.17596 8L8.8224 7.64644L6.19181 5.01585C6.1386 4.95954 6.10922 4.88478 6.10989 4.80722C6.11057 4.72856 6.14212 4.65332 6.19775 4.59769C6.25337 4.54207 6.32861 4.51052 6.40727 4.50984C6.48483 4.50916 6.55959 4.53855 6.6159 4.59176L9.81204 7.7879C9.81206 7.78791 9.81208 7.78793 9.8121 7.78795C9.8683 7.8442 9.89988 7.92047 9.89988 8C9.89988 8.07952 9.8683 8.15579 9.8121 8.21204C9.81208 8.21206 9.81206 8.21208 9.81204 8.2121L6.61215 11.412L9.17596 8Z",
    fill: "#D1D5DB",
    stroke: "#6B7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectChevronRight);
export default __webpack_public_path__ + "static/media/select-chevron-right.b661bf1e06c92495a8aa47116965127c.svg";
export { ForwardRef as ReactComponent };